import { BREAKPOINTS } from "./constants";

type ImageConfig = {
  crop?:
    | "16:9"
    | "16:10"
    | "2:1"
    | "5:1"
    | "1:1"
    | "4:3"
    | "3:2"
    | "2:3"
    | "3:4"
    | "6:7"
    | "9:16"
    | "45:64"
    | "50:19";
  width?: number;
  height?: number;
  quality?: number;
};
export const createImageUrl = (src: string, config?: ImageConfig): string => {
  const url = new URL(src.startsWith("http") ? src : `https:${src}`);
  if (config?.crop) url.searchParams.set("crop", config?.crop + ",smart");
  if (config?.width) url.searchParams.set("width", config.width.toString());
  if (config?.height) url.searchParams.set("height", config.height.toString());
  if (config?.quality)
    url.searchParams.set("quality", config.quality.toString());
  return url.href;
};
export const createImageSizes = ({
  mobile,
  tablet,
  desktop,
}: {
  mobile: string;
  tablet: string;
  desktop: string;
}) => {
  const imageSizes = [];

  if (mobile) {
    imageSizes.push(`(max-width: ${BREAKPOINTS.sm}px) ${mobile}`);
  }

  if (tablet) {
    imageSizes.push(`(max-width: ${BREAKPOINTS.lg}px) ${tablet}`);
  }

  if (desktop) {
    imageSizes.push(desktop);
  }

  return imageSizes.join(", ");
};
